import React, { useEffect } from "react"
import PropTypes from "prop-types"
import Typography from "../UI/Typography/Typography"
import Link from "../UI/Link/Link"
import Image from "../UI/Image/Image"
import useImage from "../../hooks/useImage"
import Video from "../UI/Video/Video"
import { get } from "../../helpers/utils"
import * as styles from "./ImageWithText-tw-styles"
import MapFunctionality from "../MapFunctionality"
import { screen, render } from "@testing-library/react"

const ImageWithText = props => {
  const {
    heading,
    description,
    images,
    link,
    isReversed,
    headingIsLink,
    buttonLink,
    hasContent,
    elementId = "",
    formLink,
    isClafeActive,
    showBackground,
    descriptionForImage,
    video,
    leftHeading,
    categoryLinksCollection,
    variant,
    isLinkBelowImage,
    mainHeading,
    cameoImages = {}
  } = { ...props }
  const { foregroundImg, backgroundImg, altText } = useImage(images)

  const desc =
    typeof description === "object" ? description?.description : description

  const categoryArr =
    categoryLinksCollection && get(categoryLinksCollection, "items", [])

  const bgStyle = {}
  if (showBackground && backgroundImg) {
    bgStyle.backgroundImg = `url(${backgroundImg?.url})`
  }

  const style = styles[variant] || styles.defaultStyle

  const cameoImagesCollection = screen?.isMobile
  ? [cameoImages?.cameoMediumMobile, cameoImages?.cameoLargeMobile]
  : [cameoImages?.cameoMedium, cameoImages?.cameoLarge]

  const  handletwitterLoad =()=>{
    const script = document.createElement('script');
    script.src="https://platform.twitter.com/widgets.js";
    script.id = 'twitter-twit'
    document.head.appendChild(script)
  }

  useEffect(()=>{
    var twit = document.getElementById('twitter-twit')
    if (document.getElementsByTagName('blockquote')?.length >0 && !twit){
    handletwitterLoad()
    }
  },[])

  return (
    <div className={style?.wrapperFullBg} id={elementId}>
      
      <div className={style?.wrapper} style={bgStyle}>
        {variant === "RIGHT_IMG_LEFT_TEXT" || variant === "HOMEPAGE_LEFT_IMAGE" || variant=== "HOMEPAGE_LEFT_IMAGE" || variant === "HOMEPAGE_RIGHT_IMAGE"
          ? ""
          : mainHeading && (
              <Typography
                className={style?.mainHeading}
                content={mainHeading}
              />
            )}
        {backgroundImg && !showBackground && (
          <div className={style?.bgImg}>
            <Image contentfulImage={backgroundImg} />
          </div>
        )}

        <div
          className={`${style?.imgTxtContainer} ${
            isReversed ? style?.reverse : ""
          }`}
        >
          {foregroundImg && (
            <div className={style?.imgWrapper}>
              <span className={style?.gradBg}></span>
              <div className={style?.subimgWrpr}>
                {leftHeading && heading ? (
                  headingIsLink ? (
                    <Link {...link} className={style?.textLink}>
                      {heading}
                    </Link>
                  ) : (
                    <Typography className={style?.textHead} content={heading} />
                  )
                ) : null}
                <Image
                  contentfulImage={foregroundImg}
                  className={style?.textImg}
                  alt={altText}
                  ariaLabel={altText}
                />
                {descriptionForImage && (
                  <Typography
                    className={style?.textDesc}
                    allow_br_tag={true}
                    content={descriptionForImage}
                  />
                )}
              </div>
              {isLinkBelowImage && link && (
                <Link {...link} className={style?.textLink} />
              )}
            </div>
          )}
          {video && (
            <div className={style?.videoWrapperContainer}>
              <Video
                {...video}
                isImageToggle={true}
                className={style?.videoWrapper}
              />
              {video?.isCaption && (
                <Typography className={style?.caption} content={video?.title} />
              )}
              {isLinkBelowImage && link && (
                <Link {...link} className={style?.textLink} />
              )}
            </div>
          )}
              {(cameoImages && screen?.isMobile && cameoImages?.cameoMediumMobile) ? <div className={style?.imageWrapperMedium}>
                    <Image src={cameoImages?.cameoMediumMobile?.url} /> </div> : <div className={style?.imageWrapperMedium}>
                    <Image src={cameoImages?.cameoMedium?.url} />
                  </div>
              }{(cameoImages && screen?.isMobile && cameoImages?.cameoLargeMobile) ? <div className={style?.imageWrapperLarge}>
              <Image src={cameoImages?.cameoLargeMobile?.url} /> </div> : <div className={style?.imageWrapperLarge}>
              <Image src={cameoImages?.cameoLarge?.url} />
                </div>
              }

          {categoryArr?.length !== 0 && (
            <div className={style?.BusLink}>
              {categoryArr?.map((item, index) => (
                <div key={index} className={style?.BusLinkIn}>
                  <Link {...item} className={style?.BusLinkL} />
                </div>
              ))}
            </div>
          )}
          <div
            className={`${hasContent ? style?.textContent : style?.textWrpr}`}
          >
            {variant === "RIGHT_IMG_LEFT_TEXT" ||
            variant === "LEFT_IMG_RIGHT_TEXT" || variant === "HOMEPAGE_LEFT_IMAGE" || variant === "HOMEPAGE_RIGHT_IMAGE"? (
              <Typography
                className={style?.mainHeading}
                content={mainHeading}
              />
            ) : (
              ""
            )}
            {!leftHeading && heading ? (
              headingIsLink ? (
                <Link {...link} className={style?.textLink}>
                  {heading}
                </Link>
              ) : (
                <Typography className={style?.textHead} content={heading} />
              )
            ) : null}
            {desc != "IndiaMap" ?(
              <Typography
                content={desc}
                className={style?.textDesc}
                allow_br_tag={true}
              />
            ):<MapFunctionality />
            }
            {isClafeActive && formLink ? (
              <Link {...formLink} className={style?.textLink} />
            ) : (
              (isLinkBelowImage === null || !isLinkBelowImage) &&
              link && (
                <div className={style?.textLinkWrapper}>
                  {" "}
                  <Link {...link} className={style?.textLink} />{" "}
                </div>
              )
            )}
          </div>
        </div>
        {buttonLink && (
          <div className={style?.buttonLinkWrpr}>
            <Link {...buttonLink} className={style?.textLink} />
          </div>
        )}
      </div>
      
  
    </div>
  )
}

export default ImageWithText

ImageWithText.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  headingIsLink: PropTypes.bool,
  link: PropTypes.object,
  foregroundImg: PropTypes.object,
  style: PropTypes.object,
  isReversed: PropTypes.bool,
  hasContent: PropTypes.bool,
  backgroundImg: PropTypes.object,
  elementId: PropTypes.string,
  formLink: PropTypes.object,
  isClafeActive: PropTypes.bool,
  showBackground: PropTypes.bool,
  video: PropTypes.object,
  variant: PropTypes.string,
  categoryLinksCollection: PropTypes.object,
  isLinkBelowImage: PropTypes.bool,
  mainHeading: PropTypes.string,
}
